import React from "react";
import AppRouter from "./AppRouter";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import "./App.css";
import store from "./redux/store";
import { theme } from "./styles/theme";
import { ThemeProvider } from "@mui/styles";
import { makeStyles } from "@mui/styles";
const useStyles = makeStyles({
  loader: {
    position: "fixed",
    top: "100px",
    width: "100%",
    zIndex: 1400,
    [theme.breakpoints.up("tablet")]: {
      top: "100px",
      zIndex: 1,
    },
  },
});

function App() {
  const classes = useStyles();
  return (
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <Router>
          <AppRouter loader={classes.loader} />
        </Router>
      </Provider>
    </ThemeProvider>
  );
}

export default App;
